import React, { useEffect } from "react";
import { css } from "@emotion/css";
import { Box, Drawer, Grid, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const DrawerFormStyles = css`
  .wrapper {
    width: 100%;
    max-width: 400px;
    height: 100vh;
    overflow-y: auto;
    padding: 10px 20px;
    box-sizing: border-box;
    position: relative;
  }
`;

const DrawerForm = ({ openDrawer, onCloseDrawer, children }) => {
  const onClose = () => {
    onCloseDrawer(false);
  };

  // Lock body scroll when drawer is open
  useEffect(() => {
    if (openDrawer) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [openDrawer]);

  return (
    <Drawer
      anchor="right"
      open={openDrawer}
      onClose={onClose}
      ModalProps={{
        disableScrollLock: false, // keep this to prevent body scroll
        disablePortal: true, // keep this to prevent portal issues
        keepMounted: false, // let it unmount to avoid broken init
      }}
    >
      <Box className={DrawerFormStyles}>
        <Box className="wrapper">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <IconButton onClick={onClose}>
                <ClearIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            {children}
          </Grid>
        </Box>
      </Box>
    </Drawer>
  );
};

export default DrawerForm;
